<template>
    <div
        class="flex-shrink-0 relative focus:outline-none transition duration-150 ease-in-out cursor-pointer"
        @click="openDropdown = !openDropdown"
        @keydown.esc="openDropdown = false"
        v-on-clickaway="closeDropdown"
        tabindex="0"
    >
        <slot name="user-information"></slot>
        <transition
            enter-active-class="transition ease-out duration-100 transform"
            enter-class="opacity-0 scale-95"
            enter-to-class="opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75 transform"
            leave-class="opacity-100 scale-100"
            leave-to-class="opacity-0 scale-95"
        >
            <div
                class="origin-top-right navbar-dropdown absolute right-0 mt-2 w-48 rounded-md shadow-lg z-10"
                v-show="openDropdown"
            >
                <slot name="user-dropdown"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    data: () => ({
        openDropdown: false,
    }),

    methods: {
        closeDropdown() {
            this.openDropdown = false;
        },
    },

    mixins: [clickaway],
};
</script>
